import { custom, deserialize, serializable } from 'serializr';
import { Base, PageObject } from '@testsigma/organism';
import { ExternalApplicationConfig } from './external-application-config.model';
import { EntityType } from '../enums/entity-type.enum';

export class EntityExternalMapping extends Base implements PageObject {
  @serializable
  public id: number;
  @serializable
  public applicationId: number;
  @serializable
  public entityType: EntityType;
  @serializable
  public entityId: number;
  @serializable
  public externalId: string;
  @serializable
  public linkToExisting: boolean;
  @serializable
  public message: string;
  @serializable
  public pushFailed: boolean;
  @serializable(
    custom(
      (v) => {
        return v;
      },
      (v) => v,
    ),
  )
  public fields: Map<string, Object>;
  @serializable
  public assetsPushFailed: boolean;

  @serializable
  public misc: string;
  public application: ExternalApplicationConfig;

  deserialize(input: any): this {
    return Object.assign(this, deserialize(EntityExternalMapping, input));
  }
}
